export default ($axios) => ({
    getAdvantages() {
        return $axios({
            method: 'GET',
            url: '/base/advantage/main_page',
        })
    },
    getAdvantagesCategoryPage() {
        return $axios({
            method: 'GET',
            url: '/base/advantage/category_page',
        })
    },
    getAdvantagesProductPage() {
        return $axios({
            method: 'GET',
            url: '/base/advantage/product_page',
        })
    },
    getAdvantagesProduct() {
        return $axios({
            method: 'GET',
            url: '/base/advantage/product_why_we',
        })
    },
})